<script >
	import Hero from "./Hero.svelte";
	import About from "./About.svelte";
	import Footer from "./Footer.svelte";
	import OurProducts from "./OurProducts.svelte";
	import OurModels from "./OurModels.svelte";
	import Nav from "./Nav.svelte";
	
	export let id = null;


</script>



<Nav changeNavElement={false}/>
<main id="main">
	
	<div class="mainContainer" id="mainContainer">
		<div class="orangeSide"> 
			<Hero/>
		</div>
	</div>

	<About />

	
	<OurProducts />
	
	
	<OurModels/>

	<Footer/>
</main>


<style>

	:root{
		--brand: #FFAE6A;		
	}

	@media only screen and (max-width: 600px){

		main {
			width:100%;
			height:100%;
			background-color: white;
			display: block;
			overflow-y: scroll;
			overflow-x: hidden;
			scrollbar-width: none;
			scroll-snap-type: y proximity;
			position: relative;
			scroll-behavior: smooth;
		}

		main::-webkit-scrollbar {
		    width: 0em;
		}

		.mainContainer{
			width:100vw;
			height:100vh;
			background-color: transparent;
			display: flex;
			flex-direction: row;
			scroll-snap-align: start;
		}

		.orangeSide{
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center center;
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			animation-duration: 30s;
			animation-name: orangeSlide;
			animation-iteration-count: infinite;
			animation-timing-function: ease-in;
			will-change: transform;
		}

		@keyframes orangeSlide {
			0%{
				background-image: url('/img/mediterranean_img/seaAndEarth.jpg');
				background-position: center right;
			}
			20% {
				background-image: url('/img/mediterranean_img/sausageTable.jpg');
				background-position: left center;
				
			}
			40%{
				background-image: url('/img/mediterranean_img/cheese.jpg');
				background-position: center right;
				
			}
			80%{
				background-image: url('/img/mediterranean_img/milk2.jpg');
				background-position: center right;
				
			}
			100% {
			
				background-image: url('/img/mediterranean_img/cheeseRow.jpg');
				background-position: left center;

			}
		}
	}

	/*desktop mode*/
	@media only screen and (min-width: 768px) {

		main {
			width:100%;
			height:100vh;
			background-color: white;
			display: block;
			overflow: scroll;
			overflow-x: hidden;
			scrollbar-width: none;
			scroll-snap-type: y mandatory;
			position: relative;
		}

		main::-webkit-scrollbar {
		    width: 0em;
		}

		.mainContainer{
			width:100vw;
			/*height:100vh;*/
			min-height: 100vh;
			background-color: white;
			display: flex;
			flex-direction: row;
			scroll-snap-align: start;
		}

		.orangeSide{
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center center;
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			animation-duration: 30s;
			animation-name: orangeSlide;
			animation-iteration-count: infinite;
			animation-timing-function: ease-in;
			will-change: transform;
		}

		@keyframes orangeSlide {
			0%{
				background-image: url('/img/mediterranean_img/seaAndEarth.jpg');
				background-position: center right;
			}
			20% {
				background-image: url('/img/mediterranean_img/sausageTable.jpg');
				background-position: left center;
				
			}
			40%{
				background-image: url('/img/mediterranean_img/cheese.jpg');
				background-position: center right;
				
			}
			80%{
				background-image: url('/img/mediterranean_img/milk2.jpg');
				background-position: center right;
				
			}
			100% {
			
				background-image: url('/img/mediterranean_img/cheeseRow.jpg');
				background-position: left center;

			}
		}
	}
</style>